import "~/styles/vendor/bootstrap-datetimepicker.scss";
import "~/misc/vendor/bootstrap-datetimepicker.js";

export function initDatetimepicker() {
  //console.log('initDatetimepicker');
  $(".datetimepicker").datetimepicker({
    showClear: true,
  });
}
